<template>
    <router-view>
        
    </router-view>
</template>

<script>

export default{
    name:'admin-routes-renderer',
    layout:'admin'
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/index.vue